module.exports = __webpack_public_path__ + "img/2_1-residenziale-appartamenti-2.ab53a784.png";